import classNames from "classnames";
import React, { FC } from "react";

import LogoGrocerBarSvg from "../../assets/images/LogoGrocerBar.svg";
import { useConfigContext } from "../../contexts/ConfigContext/ConfigContext";
import Condition from "../Conditional/Condition";
import { Image } from "../elements";
import "./Logo_pdd.scss";

interface IPDDLogoProps {
	"data-testid"?: string;
	className?: string;
}

const PDDLogo: FC<IPDDLogoProps> = (props) => {
	const { state: location } = useConfigContext((state) => state.location);

	return (
		<div
			data-testid={props["data-testid"] ?? "PDDLogoCntr"}
			className={classNames("LogoCntr", props.className)}
		>
			<Image src={LogoGrocerBarSvg} alt="Grocer Bar Logo" className="Logo" />
			<Condition check={!!location}>
				<div className="LogoText">{location?.name}</div>
			</Condition>
		</div>
	);
};

export default React.memo(PDDLogo);
